"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when an argument is missing
 * @param {string} argumentName
 * @param {string} explanation
 */
class MissingArgumentError extends ExtendableError_1.default {
    constructor(argumentName, explanation = '') {
        super(`Missing '${argumentName}' argument. ${explanation}`);
        this.argumentName = argumentName;
        this.explanation = explanation;
    }
}
exports.default = MissingArgumentError;
